<section class="jumbotron" [style.background]="'url('+blogContent.imgBlog+')'">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center" >
    </div>
  </div>
</section>
<section>
  <div class="container py-4">
    <div class="blog-style">
      <h1 class="text-center text-blue-qaira font-weight-bolder">{{blogContent.title}}</h1> <br> <br>
      <p class="text-justify">{{blogContent.content}}</p>
    </div>
  </div>
</section>
<section class="bg-yellow-qaira text-center text-white">
  <div class="container py-2">
    <h1>Tal vez te interesa</h1>
  </div>
</section>
<section>
  <div class="container py-4 text-center">
    <div class="row content-blog justify-content-center">
      <div class="col-lg-6" *ngFor="let item of listBlogs">
        <app-blog-item [blog]="item" [viewBtn]="true"></app-blog-item>
      </div>
    </div>
    <a  class="btn custom-cta border-btn mt-5" [routerLink]="['/blog']" >{{"app.see_more" | translate}}</a>
  </div>
</section>
